import*as e from"react";function t({controlled:t,default:a,name:r,state:u="value"}){const{current:o}=e.useRef(void 0!==t),[l,n]=e.useState(a);return[o?t:l,e.useCallback((e=>{o||n(e)}),[])]}export{t as default};
//# sourceMappingURL=useControlled.js.map
